import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BE_API_AUTH_URL } from '../constants/app.constants';
import { AuthService } from './auth.service';

export interface DayOneTourState {
  dayOneTourEligible: boolean;
  dayOneTourVersion: number;
  dayOneTourCompletedAt: string | null;
}

@Injectable({ providedIn: 'root' })
export class UserTourStateService {
  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthService
  ) {}

  getDayOneState(): Observable<DayOneTourState> {
    return this.http.get<DayOneTourState>(`${BE_API_AUTH_URL}/onboarding/day-one-tour`, {
      headers: this.authService.createAuthorizationHeader()
    }).pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  completeDayOne(version: number): Observable<DayOneTourState> {
    return this.http.patch<DayOneTourState>(`${BE_API_AUTH_URL}/onboarding/day-one-tour`, { version }, {
      headers: this.authService.createAuthorizationHeader()
    }).pipe(catchError(this.authService.handleError.bind(this.authService)));
  }
}
